import React from 'react'
import PropTypes from 'prop-types'
import { MorphReplace } from 'react-svg-morph'

function Icon({ color }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 16 16"
      className="design-iconfont"
    >
      <path
        d="M6.75623608,2 C9.3830328,2 11.5124722,4.12942791 11.5124722,6.75621033 C11.5124722,7.88951063 11.1160965,8.930233 10.4544153,9.7473073 L13.9798489,13.2727222 L13.2727442,13.9798317 L9.74730206,10.4544077 C8.93023014,11.1160622 7.88952065,11.5124207 6.75623608,11.5124207 C4.12943935,11.5124207 2,9.38299274 2,6.75621033 C2,4.12942791 4.12943935,2 6.75623608,2 Z M6.75623608,3 C4.68171906,3 3,4.68171763 3,6.75621033 C3,8.83070278 4.68171906,10.5124207 6.75623608,10.5124207 C8.83075285,10.5124207 10.5124722,8.83070278 10.5124722,6.75621033 C10.5124722,4.68171763 8.83075285,3 6.75623608,3 Z"
        fillOpacity="0.4"
        fill={color}
        fillRule="evenodd"
      />
    </svg>
  )
}

const SearchIcon = (props) => {
  const { height, width, fill } = props
  return (
    <MorphReplace width={width} height={height} fill={fill}>
      <Icon color={fill} />
    </MorphReplace>
  )
}

// 默认参数
SearchIcon.defaultProps = {
  width: 12,
  height: 12,
  fill: '#000',
}
// 参数类型
SearchIcon.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
  fill: PropTypes.string,
}

export default SearchIcon
